import { createContext } from 'react';
import { initialActionsState } from './actions';
import { initialState } from './reducer';
export default createContext({
    state: initialState,
    actions: initialActionsState,
});
